export default __webpack_public_path__ + "static/char-v-04-9dc47be8e306285a2eb128730613394c.png";